<template>
	<div class="display-flex flex-wrap">
		<div class="context-section flex-col-12">
			<FormItem :item="{ title: `Sample ${itemName || ''}`, value: sampleItemLabel }" />
		</div>
		<div class="flex-col-12 text-align-right display-flex flex-column pt-1" v-if="hasEditPermissions">
			<AppDropdownMenu :items="menuItems" offset-y>
				<template #activator>
					<h4 class="text-underline">Change sample {{ itemName }}</h4>
				</template>
			</AppDropdownMenu>
		</div>
	</div>
</template>

<script>
import { element } from '@/store/modules/selectedWorkflow/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';
import FormItem from '../TriggerEditor/FormItem.vue';
import ExtensionCommunicationService from '@/utils/extension-communication-service';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import AppService from '@/utils/AppService';
import { getService } from '@/store/modules/apps/getters';
import IframeService from '@/utils/iframe-service';
import { APP_CONFIRMATION_DIALOG_RESPONSES } from '@/components/dialogs/AppDialogs/app-confirmation-dialog.const';
import { getPlacement } from '@/store/modules/placements/getters';

const CHANGE_SAMPLE_EXTENSION_MINIMAL_VERSION = '0.1.37';

export default {
	name: 'ContextChangeSample',
	props: {
		workflowId: { type: Number },
		canManuallyChange: { type: Boolean },
		sampleItemLabel: { type: String },
		hasEditPermissions: { type: Boolean },
	},
	computed: {
		...mapGettersShorthand({ element, getService, getPlacement }),
		placement() {
			return this.getPlacement(this.element.placement);
		},
		app() {
			return this.getService(this.placement.service);
		},
		contextUrl() {
			return `https://${AppService.getAppMainHost(this.app)}/`;
		},
		itemName() {
			return this.placement?.item_name;
		},
		appName() {
			return AppService.getIntegrationName(this.app);
		},
		menuItems() {
			const items = [
				{
					text: `Choose a different ${this.itemName} in ${this.appName}`,
					onClick: () => {
						this.changeSample();
					},
				},
			];
			if (this.canManuallyChange) {
				items.push({
					text: 'Choose manually (advanced)',
					onClick: () => {
						this.$emit('change-manually');
					},
				});
			}
			return items;
		},
	},
	methods: {
		async changeSample() {
			try {
				const isExtensionInstalled = await ExtensionCommunicationService.isInstalled();
				if (
					!isExtensionInstalled ||
					!(await ExtensionCommunicationService.isExtensionVersionGTEToVersion(CHANGE_SAMPLE_EXTENSION_MINIMAL_VERSION))
				) {
					await AppDialogManagerService.openInstallExtDialog({ minimalVersion: CHANGE_SAMPLE_EXTENSION_MINIMAL_VERSION });
				}
				const dialogProps = {
					title: `Change sample ${this.itemName}?`,
					description: `Go to ${this.appName} and click on the ${this.itemName} you want to use as a sample, then come back to the builder to see the result.`,
					yesText: `Open ${this.appName}`,
					noText: 'Cancel',
					isDanger: false,
				};
				const res = await AppDialogManagerService.openConfirmationDialog(dialogProps);
				if (res === APP_CONFIRMATION_DIALOG_RESPONSES.YES) {
					ExtensionCommunicationService.startChangeSampleProcess({ workflowId: this.workflowId });
					if (!IframeService.sendMessageToParent('change_sample')) {
						// message was not sent, open new tab
						this.openNewTab();
					}
				}
			} catch {
				// if we got here, dialog was rejected
			}
		},
		openNewTab() {
			window.open(this.contextUrl, '_blank');
		},
	},
	components: { FormItem },
};
</script>

<style scoped lang="scss"></style>
